// Expose Bootstrap 5 as window.bootstrap for shared scripts in the public and BS5 admin bundles.
// Bootstrap also handles data-bs-* controls.
import * as bootstrap from "bootstrap"

window.bootstrap = bootstrap

export default bootstrap
